export enum ChannelType {
    SMS = 'SMS',
    EMAIL = 'EMAIL',
    PUSH_NOTIFICATION = 'PUSH_NOTIFICATION',
    DEVICE_OTP = 'DEVICE_OTP'
}